module.exports = __webpack_public_path__ + "static/globe-d49c077891199cde24a670dd41dd6b3b.png";